var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.4997V13.9997H4.5L11.8733 6.62634L9.37333 4.12634L2 11.4997ZM13.8067 4.69301C13.8685 4.63133 13.9175 4.55807 13.951 4.47743C13.9844 4.39678 14.0016 4.31032 14.0016 4.22301C14.0016 4.1357 13.9844 4.04924 13.951 3.96859C13.9175 3.88794 13.8685 3.81469 13.8067 3.75301L12.2467 2.19301C12.185 2.13121 12.1117 2.08218 12.0311 2.04872C11.9504 2.01527 11.864 1.99805 11.7767 1.99805C11.6894 1.99805 11.6029 2.01527 11.5223 2.04872C11.4416 2.08218 11.3683 2.13121 11.3067 2.19301L10.0867 3.41301L12.5867 5.91301L13.8067 4.69301Z",
    fill: "#481AA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.36cad852616bf8b1b5f388ae7b83746d.svg";
export { ForwardRef as ReactComponent };